import { Navigate, useLocation } from 'react-router-dom';

const LegacyDocumentsRedirect = () => {
  const { search, hash, state } = useLocation();

  return (
    <Navigate
      to={{ pathname: '/documents', search, hash }}
      state={state}
      replace
    />
  );
};

export default LegacyDocumentsRedirect;
